import { ProviderTypes } from "interfaces/interfaces";

const config  =  {
    "provider" :        ProviderTypes.custom,
    "urlAPI" :          process.env.REACT_APP_URL_API || "-",
    "env" :             process.env.REACT_APP_DEV || "-",
    "urlResources":     process.env.REACT_APP_URLRESOURCES+"",
    "urlSitelibros":    process.env.REACT_APP_URL_SITELIBROS+"",
    "urlSiteinfografia": process.env.REACT_APP_URL_SITEINFOGRAFIA+"",
    "ACCESSGOOGLE":     process.env.REACT_APP_ACCESSGOOGLE+"",
}

export {config};